module.exports = __webpack_public_path__ + "static/media/family_relationships-min.bd5bb0a0.jpg";